import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { installApiAuth } from './services/identity'
import { IdentityProvider } from './components/Identity'
import ActivationPage from './pages/activation/ActivationPage'
import InvitationPage from './pages/invitation/InvitationPage'
import './index.css'

installApiAuth()

// /activate#<token> is the public one-time account activation: rendered on its own, before any
// sign-in or identity lookup (it never creates a session).
const activation = window.location.pathname === '/activate'
// /reset-password#<token>: the administrator-issued password reset (same one-time-link handling).
const reset = window.location.pathname === '/reset-password'
// /invite#<token>: accepting an invitation (Microsoft, Google or a RadioOS password); the former
// /platform-invitation links lead to the same page.
const invitation = window.location.pathname === '/invite' || window.location.pathname === '/platform-invitation'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {invitation ? (
      <InvitationPage />
    ) : activation || reset ? (
      <ActivationPage purpose={reset ? 'reset' : 'activation'} />
    ) : (
      <BrowserRouter>
        <IdentityProvider>
          <App />
        </IdentityProvider>
      </BrowserRouter>
    )}
  </React.StrictMode>,
)
